<div [innerHTML]="content | safeHtml" #contentHtml></div>
